<template>
  <div class='home'>
    <div class='hero' :style="{backgroundImage: 'url('+require('@/assets/img/hero.jpg')+')'}">
      <div class='dark'></div>
      <div class='contain'>
        <h1>Become a popshap Reseller.</h1>
        <div class='btns'>
          <button @click='$router.push({path: "/register"})' class='btn'>Register</button>
          <button @click='showLogin()' class='btn text_btn'>Login</button>
        </div>
      </div>
    </div>

    <div class='img-text'>
      <div class='contain'>
        <div class='text'>
          <h2>Complete Control</h2>
          <p>As a reseller of popshap we give you all the tools to succeed. Our software will let you manage and keep track of all your orders, clients and inverntory</p>
          <div class='btns'>
            <button @click='$router.push({path: "/register"})' class='btn'>Get Started</button>
          </div>
        </div>
        <img src='@/assets/img/dashboard.png'>
      </div>
    </div>

    <div class='img-text right color btm'>
      <div class='contain'>
        <div class='text'>
          <h2>Hottest Hardware</h2>
          <p>As a popshap reseller you have access to the newest / most popular tech. Take advantage of our innovative solutions that continue to grow with the world.</p>
          <div class='btns'>
            <button @click='$router.push({path: "/register"})' class='btn'>Get Started</button>
          </div>
        </div>
        <img src='@/assets/img/hardware.png'>
      </div>
    </div>

     <register></register>

    <footer>
      <div class='contain'>
        <p>popshap resellers</p>
        <p>888-317-5531</p>
      </div>
    </footer>
  </div>

</template>

<script>
  import Popup from '@/components/Popup';
  import Register from '@/components/Register';
  import firebase from "firebase";
  const fb = require('../firebaseConfig.js');
  const db = fb.default.db;

export default {
  name: 'home',
  components: {
    'popup': Popup,
    'register': Register
  },
  data(){
    return {
      user: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        comments: null
      }
    }
  },
  mounted(){
  },
  created() {
  },
  updated() {
  },
  methods: {
  }
}
</script>

<style lang='scss'>
.hero {
  position: relative;
  height: 100vh;
  min-height: 600px;
  background-size: cover;
  background-position: center;
  .dark {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 0;
    background: linear-gradient(rgba(36, 51, 68, 0),rgba(36, 51, 68, 1))
  }
  .contain {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
    padding-bottom: 75px;
    h1 {
      color: white;
      max-width: 1000px;
      @media screen and (max-width: 700px){
        font-size: 58px;
      }
    }
  }
}

.img-text {
  .contain {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 900px){
      flex-direction: column;
      padding-top: 50px;
      padding-bottom: 50px;
    }
    .text {
      max-width: 500px;
      @media screen and (max-width: 900px){
        max-width: 100%;
      }
      h2 {
        font-size: 36px;
        margin-top: 20px;
        margin-bottom: 35px;
        font-weight: bold;
        @media screen and (min-width: 1500px){
          font-size: 50px;
        }
      }
      .btns {
        margin-top: 40px;
        @media screen and (max-width: 900px){
          margin-bottom: 40px;
          margin-top: 20px;
        }
      }
    }
    img {
      max-width:550px;
      @media screen and (max-width: 1100px){
        max-width:450px;
      }
      @media screen and (max-width: 900px){
        max-width:550px;
        width: 100%;
      }
    }
  }
  &.color {
    background-color: rgba(110, 196, 210, 0.14);
  }
  &.right {
    .contain {
      flex-direction: row-reverse;
      @media screen and (max-width: 900px){
        padding-top: 50px;
        flex-direction: column;
      }
    }
  }
  &.right {
    .contain {
      padding-bottom: 0;
    }
  }
}
</style>
